<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  beforeCreate(){
    document.title = window.settings.customization?.title == null ? "İzOnay" : window.settings.customization.title;
  },
  data(){
    return {
    }
  },
  methods:{

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
